import { Contatos as dados } from '../data/Contatos.ts';


export const Contato = () => {
    return (
        <>
            <footer className="sobreArea">
                <h1>Contato</h1>
                <p className="text-center">
                    Para entrar em contato, basta conferir as redes e informações abaixo!
                </p>

                <div className="rodape-area d-flex justify-content-between">
                    {/* Lado esquerdo */}
                        <ul className='footer-lista'>
                            {dados.map((item,index) => (
                                <li className='nav-item footer-li' key={index}>
                                    {item.tipo}:
                                    <a  
                                        className='nav-link active font-bold'
                                        href={
                                            item.tipo === 'email'
                                                ? `mailto:${item.valor}`
                                                : item.tipo === 'telefone'
                                                ? `${item.valor}` 
                                                : item.tipo === 'linkedin'
                                                ? `https://${item.valor}` 
                                                : item.valor
                                        }
                                        target={item.tipo !== 'email' ? '_blank' : '_self'}
                                        rel={item.tipo !== 'email' ? 'noopener' : ''}
                                        >
                                           <strong className='a'>{item.valor}</strong> 
                                    </a>
                                </li>
                            ))}
                        </ul>
                </div>
            </footer>
        </>
    );
};
